/*
  Строка дома без участка (вынесена из `UnassignedList.jsx` 21.10.2026, когда список стал
  постраничным и файл перестал помещаться в предел размера компонента).

  Три вида строк, и все решает сервер, а не экран (`bindable`, `missing`):
  - дом готов к привязке - кнопка;
  - в записи выгрузки нет населённого пункта («Дом 31А») - сначала полный адрес;
  - дом от квартиры отделить нельзя («ул. Ленина, 3-14») - кнопки нет, такой дом
    заводится вручную.
*/

import { Lock } from './AccessContext.jsx'
import { Field, Tag } from './Common.jsx'

export default function UnassignedHouseRow({
  house,
  title,
  isOpen,
  full,
  onOpen,
  onClose,
  onFull,
  onAttach,
}) {
  const count = (
    <td className="table__num" data-label="Помещений">
      {house.premises_count}
    </td>
  )

  if (!house.bindable) {
    return (
      <tr>
        <td className="table__block">
          {house.address}
          <div className="muted">
            Дом и квартиру здесь не различить - заведите дом вручную в форме ниже.
          </div>
        </td>
        {count}
        <td>
          <Tag>вручную</Tag>
        </td>
      </tr>
    )
  }

  const incomplete = house.missing.length > 0
  return (
    <tr>
      <td className="table__block">
        {house.address}
        {incomplete ? (
          <div>
            <Tag kind="warn">без {house.missing.join(' и ')}</Tag>{' '}
            <span className="muted">в заявление уйдёт полный адрес, который вы впишете</span>
          </div>
        ) : null}
        {isOpen ? (
          <form
            className="row"
            onSubmit={(event) => {
              event.preventDefault()
              onAttach(full.trim())
            }}
          >
            <Field label="Полный адрес дома" width="m">
              <input
                className="field__input"
                value={full}
                onChange={(event) => onFull(event.target.value)}
                placeholder={`г. Кемерово, ${house.address}`}
              />
            </Field>
            <button className="button" type="submit" disabled={!full.trim()}>
              {title}
            </button>
            <button className="button button--quiet" type="button" onClick={onClose}>
              Отмена
            </button>
          </form>
        ) : null}
      </td>
      {count}
      <td>
        {/* Привязка - запись: при неоплаченной лицензии кнопка гаснет (строка 291 реестра). */}
        <Lock>
          {incomplete ? (
            isOpen ? null : (
              <button className="button button--quiet" type="button" onClick={onOpen}>
                Вписать полный адрес
              </button>
            )
          ) : (
            <button className="button" type="button" onClick={() => onAttach(null)}>
              {title}
            </button>
          )}
        </Lock>
      </td>
    </tr>
  )
}
